import { TAssetsSvgMapValue } from '../assets';
import { TCommonData, TCommonMessages, TItem } from './data';
import { TWAction } from './widget';

type TRate = {
    to: string;
    from: string;
};
export type TFeeOptionFee = {
    value?: string;
    currency?: string;
    label: string;
};
export type TFeeOption = {
    optionName: string;
    optionFee: TFeeOptionFee;
};
export type TFee = {
    sum: string;
    currency: string;
    iconName: TAssetsSvgMapValue;
};

export enum ECalculatorErrorType {
    EXCEED_PROFILE_LIMIT = 'EXCEED_PROFILE_LIMIT',
    EXCEEDING_WITHDRAWAL_LIMIT = 'EXCEEDING_WITHDRAWAL_LIMIT',
    EXCEED_LIMIT_TRANSACTION = 'EXCEED_LIMIT_TRANSACTION',
    MIN_AMOUNT = 'MIN_AMOUNT',
    INVALID_CODE = 'INVALID_CODE',
    INVALID_CODE_LOCK = 'INVALID_CODE_LOCK',
}

export enum ECalculatorErrorField {
    FROM = 'FROM',
    TO = 'TO',
    CODE = 'CODE',
}

export type TCalculatorError = {
    type: ECalculatorErrorType;
    changeAmount?: boolean;
    changeDeliveryOptions?: boolean;
    changeTransferOptions?: boolean;
    increaseLimitOptions?: boolean;
    gotIt?: boolean;
    field: ECalculatorErrorField;
    longText?: string;
    shortText?: string;
    newInputValue?: string;
    maxWithdrawValue?: string;
    withdrawButtonText?: string;
    withdrawCurIso?: string;
    withdrawButtonVisible: boolean;
    actions?: TWAction[];
};
export type TCalculatorMessages = {
    codeTextEnter?: string;
    codeTextApplied?: string;
    codeTextLock?: string;
    codeTextUse?: string;
    codeLabelNewCode?: string;
    codeLabelRemoveCode?: string;
    codeButtonLabel: string;
    codeTextAddedCode?: string;
    codeTextRemovedCode?: string;
    codeLabelUseCode?: string;
    searchPlaceholder?: string;
    buttonLabel: string;
    buttonLabelMain: string;
    buttonGotItLabel?: string;
    buttonChangeAmountLabel?: string;
    buttonChangeDeliveryOptionLabel?: string;
    buttonChangeTransferOptionLabel?: string;
    buttonIncreaseLimitLabel?: string;
    buttonInactiveLabelMain: string;
    feeBottomSheetButton: string;
    feeLabel: string;
    feeText: string;
    fromInputLabel: string;
    toInputLabel: string;
    inputLabel: string;
    listFromCurrencyText: string;
    listToCurrencyText: string;
    listFromCurrencyButton: string;
    listToCurrencyButton: string;
    rateLabel: string;
    noResultFoundText?: string;
    feeBottomSheetFirstText: string;
    feeBottomSheetSecondText: string;
    feeBottomSheetOptions: TFeeOption[];
    confirmInfoText: string;
    currencyListText: string;
    currencyListItemSubtitleText: string;
} & TCommonMessages;
type TCode = {
    handlingAutoApplied?: boolean;
};
export type TBaseCalculatorData = {
    fee: TFee;
    listCurrency: TItem[];
    errors: TCalculatorError[] | null;
    messages: TCalculatorMessages;
    buttonContinueEnabled: boolean;
    tabIndex?: number;
} & TCommonData;
export type TCalculatorData = {
    rate: TRate;
    code: TCode;
} & TBaseCalculatorData;

export type TCalculatorTopUpData = TBaseCalculatorData & TCommonData;
